var map = {
	"./parceiro1.jpg": 7258,
	"./parceiro10.jpg": 9816,
	"./parceiro11.jpg": 997,
	"./parceiro12.jpg": 506,
	"./parceiro13.jpg": 2663,
	"./parceiro14.jpg": 8252,
	"./parceiro15.jpg": 6249,
	"./parceiro16.jpg": 7582,
	"./parceiro17.jpg": 3419,
	"./parceiro18.jpg": 1664,
	"./parceiro19.jpg": 2589,
	"./parceiro2.jpg": 3509,
	"./parceiro20.jpg": 3865,
	"./parceiro21.jpg": 8492,
	"./parceiro22.jpg": 4939,
	"./parceiro23.jpg": 158,
	"./parceiro24.jpg": 4629,
	"./parceiro25.jpg": 2264,
	"./parceiro26.jpg": 6487,
	"./parceiro27.jpg": 2026,
	"./parceiro28.jpg": 3169,
	"./parceiro29.jpg": 5124,
	"./parceiro3.jpg": 6344,
	"./parceiro30.jpg": 2210,
	"./parceiro31.jpg": 8591,
	"./parceiro32.jpg": 5600,
	"./parceiro33.jpg": 1165,
	"./parceiro4.jpg": 6347,
	"./parceiro5.jpg": 4862,
	"./parceiro6.jpg": 7945,
	"./parceiro7.jpg": 9900,
	"./parceiro8.jpg": 1615,
	"./parceiro9.jpg": 9234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2562;